import { AnalyticsEvents, trackEvent } from "@axqora/analytics";
import type { Locale, PageKind } from "../content/types";
import { localeHref, otherLocale, saveLocale } from "../i18n/routes";

type LanguageSwitchProps = {
  locale: Locale;
  kind: PageKind;
  label: string;
};

export function LanguageSwitch({ locale, kind, label }: LanguageSwitchProps) {
  const target = otherLocale(locale);
  const href = localeHref(target, kind);

  return (
    <a
      href={href}
      className="inline-flex items-center gap-1.5 rounded-full border border-subtle px-3 py-1.5 text-[13px] font-medium text-text-secondary transition-colors hover:text-text-primary"
      aria-label={`Switch language to ${label}`}
      onClick={() => {
        saveLocale(target);
        trackEvent(AnalyticsEvents.LanguageSwitch, {
          product: "luxoria",
          page: kind,
          from: locale,
          to: target
        });
      }}
    >
      {label}
    </a>
  );
}
